import React from 'react';

interface Partner {
  id: number;
  name: string;
}

interface Props {
  partners: Partner[];
  onSelect: (partnerId: number) => void;
}

export default function PartnersListTab({ partners, onSelect }: Props) {
  if (partners.length === 0) {
    return (
      <section className="admin-partners-list">
        <p>No partners found.</p>
      </section>
    );
  }
  return (
    <section className="admin-partners-list">
      <div className="partner-card-grid">
        {partners.map((p) => (
          <div
            key={p.id}
            className="partner-card"
            onClick={() => onSelect(p.id)}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                onSelect(p.id);
              }
            }}
          >
            <div className="partner-card__name">{p.name}</div>
            <div className="partner-card__links">
              <span>Pricing</span>
              <span>·</span>
              <span>Vehicles</span>
              <span>·</span>
              <span>Service Areas</span>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
